<template>
  <div class="sub-menu-mobile">
    <BaseContainer>
      <FormSelect semi/>
    </BaseContainer>
  </div>
</template>

<script>
import FormSelect from '../elements/FormSelect.vue'
import BaseContainer from '../elements/BaseContainer.vue'
export default {
  name: 'SubMenuMobile',
  components: { BaseContainer, FormSelect }
}
</script>


<style lang="postcss">
.sub-menu-mobile {
  @apply block bg-primary-lightest;
}
@screen lg {
  .sub-menu-mobile {
    @apply hidden;
  }
}
</style>
